export const API_ENDPOINTS = {
  CHAT: '/chat',
  CONVERSATIONS: '/api/conversations',
  AUTH: '/api/auth',
  HEALTH: '/health',
} as const;

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;

/** Bump when session shape changes — clears legacy auto-login data once. */
export const AUTH_SESSION_VERSION = '2';

export const STORAGE_KEYS = {
  AUTH_SESSION_VERSION: 'ux3_auth_session_version',
  USER_ID: 'ux3_user_id',
  USER_EMAIL: 'ux3_user_email',
  USER_NAME: 'ux3_user_name',
  USER_FIRST_NAME: 'ux3_user_first_name',
  USER_LAST_NAME: 'ux3_user_last_name',
  USER_ROLE: 'ux3_user_role',
  USER_SITE: 'ux3_user_site',
  SIGN_IN_COUNTS: 'ux3_sign_in_counts',
  THEME: 'ux3_theme',
  ONBOARDING_DISMISSED: 'ux3_onboarding_dismissed',
  ONBOARDING_COMPLETED_STEPS: 'ux3_onboarding_completed_steps',
  SAVED_ACTIONS: 'ux3_saved_actions',
  SPACES: 'ux3_spaces',
  DEVICE_SETUP_CONVERSATIONS: 'ux3_device_setup_conversations',
  DEVICE_SETUP_STATE: 'ux3_device_setup_state',
  USER_CREATION_CONVERSATIONS: 'ux3_user_creation_conversations',
  USER_CREATION_STATE: 'ux3_user_creation_state',
  ACCESS_GROUP_CREATION_CONVERSATIONS: 'ux3_access_group_creation_conversations',
  ACCESS_GROUP_CREATION_STATE: 'ux3_access_group_creation_state',
  BULK_USER_IMPORT_CONVERSATIONS: 'ux3_bulk_user_import_conversations',
  BULK_USER_IMPORT_STATE: 'ux3_bulk_user_import_state',
  PROVISIONED_USERS: 'ux3_provisioned_users',
} as const;

export const PROVISIONED_USERS_CHANGED_EVENT = 'ux3-provisioned-users-changed';
export const ONBOARDING_PROGRESS_CHANGED_EVENT = 'ux3-onboarding-progress-changed';

export const WORKFLOW_QUERY = {
  DEVICE_SETUP: 'device-setup',
  USER_CREATION: 'user-creation',
  ACCESS_GROUP_CREATION: 'access-group-creation',
  BULK_USER_IMPORT: 'bulk-user-import',
} as const;

export const QUERY_KEYS = {
  CONVERSATIONS: 'conversations',
  CONVERSATION_DETAIL: 'conversation-detail',
  USER: 'user',
} as const;
